import { createSlice, current } from "@reduxjs/toolkit";
import { nestedTernaryCheckerCond1 } from "utils/CommonChecker";
import { sortableProperties } from "utils/CommonConstants";

const sortInitial: any = {
  plansSort_myList: {
    property: "planTitle",
    order: "asc"
  },
  propertiesSort_myList: { property: "inncode", order: "asc" },
  plansSort_dashboard: {
    property: "planTitle",
    order: "asc"
  },
  propertiesSort_dashboard: { property: "inncode", order: "asc" },
  adminConsole: { property: "lastLoggedInDate", order: "asc" },
  propertyPlan: { property: "title", order: "asc" },
  planProgressScreen: { property: "planCreatedDate", order: "asc" },
  propertyProgressScreen: { property: "planCreatedDate", order: "asc" },
  usersProgressScreen: { property: "planCreatedDate", order: "asc" },
  manageSuggestions: { property: "inncode", order: "asc" },
  feedbackForms: { property: "triggerPoint", order: "asc" }
};

const initialState: any = {
  sorting: sortInitial
};
function isRejectedAction(action: any) {
  return action.type.endsWith("rejected");
}

export const SortingSlice = createSlice({
  name: "sorting_slice",
  initialState,
  reducers: {
    reset: () => initialState,
    setSorting: (state, action) => {
      const { tableName, header, key } = action.payload;
      const sortableType = key ?? sortableProperties[header];
      const cond1 = current(state.sorting[tableName]).property == sortableType;
      const cond2 = current(state.sorting[tableName]).order === "asc";
      state.sorting[tableName] = {
        property: sortableType,
        order: nestedTernaryCheckerCond1(cond1, cond2, "desc", "asc", "asc")
      };
    },
    resetSorting: (state, action) => {
      const { tableName } = action.payload;
      state.sorting[tableName] = sortInitial[tableName];
    },
    resetAllSorting: (state, action) => {
      state.sorting = sortInitial;
    },
    setSortingForSpecificCase: (state, action) => {
      state.sorting.propertyPlan = action?.payload?.reset ? { property: "title", order: "asc" } : {};
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(isRejectedAction, (state, action) => {});
  }
});
export const { reset, setSorting, resetSorting, resetAllSorting, setSortingForSpecificCase } = SortingSlice.actions;
export default SortingSlice.reducer;
